import { Injectable } from '@angular/core';
import { Statistics } from '@models/statistics.interface';

@Injectable({
    providedIn: 'root'
})
export class FactcheckerStatisticsService {
    constructor() { }

    public get getFactcheckerStatistics(): Statistics {
        return this.factcheckerTitlesIcons();
    }

    private factcheckerTitlesIcons(): Statistics {
        return [
            {
                key: 'questions_published',
                title: 'Questions Accepted',
                icon: 'circle_check_mark'
            },
            {
                key: 'questions_rejected',
                title: 'Questions Rejected',
                icon: 'question_rejected'
            },
            {
                key: 'questions_needs_review',
                title: 'Questions in Factchecking Queue',
                icon: 'question_que'
            }
        ];
    }

}
